/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Line } from '../../../../../service/interfaces/purchase'
import { useSelector } from 'react-redux'
import { enToPersianChar, phoneNumberFormat } from '../../../../../components/helper'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { ArrowLeftSVG, SadEmoticonSVG } from '../../../../../components/IconSvg'
import { IRootState } from '../../../../../service/store'
import { useLocation } from 'react-router-dom'


type Props = {
    selectANumber: Function,
    setSelectedNumber: Function,
    selectedNumber: Line | undefined,
    states: any,
    // setPrefixNumberList: Function
}
const LineList = (props: Props) => {
    const responseLines = useSelector((state: IRootState) => state.purchaseReducer.resultLines) as [Line]
    const searchFreeProposedNumbersResult: Line[] | null = useSelector((state: IRootState) => state.purchaseReducer.searchFreeProposedNumbersResult)

    const [states, setStates] = CustomValuesHook({ lines: [] })
    const location = useLocation()


    useEffect(() => {

        if (searchFreeProposedNumbersResult && props.states.isSearch) {
            setStates({ lines: searchFreeProposedNumbersResult })
        }
    }, [searchFreeProposedNumbersResult])
    useEffect(() => {
        if (responseLines && responseLines.length > 0) {
            setStates({ lines: responseLines })

        }
    }, [responseLines])



    const checkSelected = (line: Line) => {
        if (line.Id === props.selectedNumber?.Id) {
            return true;
        }
        return false;
    }

    useEffect(() => {

        if (states.lines && states.lines?.length > 0 && props?.selectedNumber) {

            if (!states.lines.some((i: Line) => i.Id === props.selectedNumber?.Id)) {

                let temp = [...states.lines]
                temp.unshift(props.selectedNumber)
                setStates({ lines: [...temp] })
            } else {
                const idx = states.lines.findIndex((item: any) => item.Id === props.selectedNumber?.Id)
                if (idx > 0) {
                    let temp = [...states.lines]
                    temp.splice(idx, 1);
                    temp.unshift(props.selectedNumber)

                    setStates({ lines: [...temp] })
                }
            }
        }
    }, [states.lines])

    return (
        <div className='line-list-container' >
            <ul className='line-list' >
                {states.lines.map((line: Line, idx: number) => {
                    return (
                        <li
                            key={idx}
                            className={`linenumber-item ${checkSelected(line) ? 'selected' : ''}`}
                            onClick={() => {
                                if (props.selectedNumber === line) {
                                    props.setSelectedNumber()
                                } else {
                                    props.setSelectedNumber(line)
                                }
                            }}>
                            {checkSelected(line) && <span className="badge-checked"></span>}
                            <strong >
                                <sup >۰۲۱&nbsp;&nbsp;</sup>
                                {enToPersianChar(phoneNumberFormat(line.Number).substring(3))}
                            </strong>
                            <span>
                                {line.Price !== 0 ? <span  >
                                    {enToPersianChar(line.Price)} تومان
                                </span> :
                                    <span className='price-spn' >
                                        رایگان
                                    </span>
                                }
                                {checkSelected(line) && <div className="next-step-btn" >
                                    <span onClick={(e) => { e.stopPropagation(); props.selectANumber(props.selectedNumber) }}>
                                        مرحله بعد
                                        {/* <i className="fa fa-angle-left"></i> */}
                                        <ArrowLeftSVG fill='#fff' />
                                    </span>
                                </div>}
                            </span>
                        </li>
                    )
                })}</ul>

            {searchFreeProposedNumbersResult?.length === 0 && props.states.isSearch && <div className='empty-search-result' >
                <div> هیچ شماره‌ای شامل {enToPersianChar(props.states.searchQuery)} یافت نشد.
                    <span><SadEmoticonSVG /></span></div>

            </div>}
        </div>
    )
}

export default LineList

